<template>
  <div class="modal is-active">
    <div @click="close()" class="modal-background"></div>
    <div class="modal-card wider-modal">
      <header class="modal-card-head flex-space-between">
        <p v-if="!editing" class="modal-card-title">
          {{ title }}
        </p>
        <input v-else
          type="text"
          class="input tag-title"
          placeholder="Update title..."
          v-model="_title"
          />
        <a v-if="!inComment && !editing && isOwnerOrGroupAdmin" @click="editTag()" class="mr-4">Edit</a>
        <a v-if="editing && isOwnerOrGroupAdmin" @click="updateTagAndRubric()">Save</a>
        <button @click="$emit('close')" class="delete"></button>
      </header>
      <section class="modal-card-body">
        <form>

          <section>
            <ul class="rubric-option-container">
                <!-- Descriptor A -->
                <li class="rubric-option"
                  @click="videoID > 0 ? scoreRubric(valA) : {}"
                  :class="{ 'is-active': selectedA, disabled: true }"
                  >
                  <section>
                    <h3 v-if="!editing" class="title is-5">{{ headerA }}</h3>
                    <input v-else
                      type="text"
                      class="input"
                      placeholder="Update title..."
                      v-model="_headerA"
                      />
                    <p v-if="!editing" class="line-breaks">{{ descA }}</p>
                    <textarea v-else
                      v-textautosize
                      type="text"
                      class="textarea"
                      placeholder="Update title..."
                      v-model="_descA"
                      />
                  </section>
                </li>
                <!-- Descriptor B -->
                <li class="rubric-option"
                  @click="videoID > 0 ? scoreRubric(valB) : {}"
                  :class="{ 'is-active': selectedB, disabled: true }"
                  >
                  <section>
                    <h3 v-if="!editing" class="title is-5">{{ headerB }}</h3>
                    <input v-else
                      type="text"
                      class="input"
                      placeholder="Update title..."
                      v-model="_headerB"
                      />
                    <p v-if="!editing" class="line-breaks">{{ descB }}</p>
                    <textarea v-else
                      v-textautosize
                      type="text"
                      class="textarea"
                      placeholder="Update title..."
                      v-model="_descB"
                      />
                  </section>
                </li>
                <!-- Descriptor C -->
                <li class="rubric-option"
                  @click="videoID > 0 ? scoreRubric(valC) : {}"
                  :class="{ 'is-active': selectedC, disabled: true }"
                  >
                  <section>
                    <h3 v-if="!editing" class="title is-5">{{ headerC }}</h3>
                    <input v-else
                      type="text"
                      class="input"
                      placeholder="Update title..."
                      v-model="_headerC"
                      />
                    <p v-if="!editing" class="line-breaks">{{ descC }}</p>
                    <textarea v-else
                      v-textautosize
                      type="text"
                      class="textarea"
                      placeholder="Update title..."
                      v-model="_descC"
                      />
                  </section>
                </li>
                <!-- Descriptor D -->
                <li class="rubric-option"
                  @click="videoID > 0 ? scoreRubric(valD) : {}"
                  :class="{ 'is-active': selectedD, disabled: true }"
                  >
                  <section>
                    <h3 v-if="!editing" class="title is-5">{{ headerD }}</h3>
                    <input v-else
                      type="text"
                      class="input"
                      placeholder="Update title..."
                      v-model="_headerD"
                      />
                    <p v-if="!editing" class="line-breaks">{{ descD }}</p>
                    <textarea v-else
                      v-textautosize
                      type="text"
                      class="textarea"
                      placeholder="Update title..."
                      v-model="_descD"
                      />
                  </section>
                </li>
                <!-- Descriptor E -->
                <li v-if="headerE" class="rubric-option"
                  @click="videoID > 0 ? scoreRubric(valE) : {}"
                  :class="{ 'is-active': selectedE, disabled: true }"
                  >
                  <section>
                    <h3 v-if="!editing" class="title is-5">{{ headerE }}</h3>
                    <input v-else
                      type="text"
                      class="input"
                      placeholder="Update title..."
                      v-model="_headerE"
                      />
                    <p v-if="!editing" class="line-breaks">{{ descE }}</p>
                    <textarea v-else
                      v-textautosize
                      type="text"
                      class="textarea"
                      placeholder="Update title..."
                      v-model="_descE"
                      />
                  </section>
                </li>

            </ul>
          </section>
        </form>

        <div class="mt-3">
          <strong class="mr-2">Videos:</strong>
          <a target="_blank" :href="'/tags/' + tagID" class="mr-4">See list of videos with this tag</a>
        </div>


      </section>
      <footer class="modal-card-foot">
        <a @click="removeScore(tagID)" v-if="score">Remove Score</a>
        <button v-if="typeof commentID === 'undefined' && isOwnerOrGroupAdmin"
          @click="showConfirm = true"
          class="button is-small is-danger is-outlined mr-4 pull-right">
          Delete
        </button>
      </footer>
      <Confirm
          :show="showConfirm"
          :message="'Are you sure you want to delete this tag? This will remove the tag from any videos you have tagged.'"
          :title="'Permanently Delete Tag'"
          :confirmFocus="true"
          :completeButtonText="'Delete'"
          @confirm="deleteTag(tagID)"
          @cancel="showConfirm = false"
        />
    </div>
  </div>
</template>

<script>

import store from '../store.js'

import RubricBox from './RubricBox.vue'
import Confirm from './Confirm.vue'

import { textautosize } from '../directives.js'

import {
  deleteTag,
  updateTagShare,
  updateTag,
  updateRubricItem,
  addScoreToComment,
  removeScoreFromComment,
} from '../actionTypes'

export default {
  name: 'RubricItemModal',
  components: {
    RubricBox,
    Confirm,
  },
  data () {
    return {
      showConfirm: false,
      editing: false,
      _title: '',
      _headerA: '',
      _headerB: '',
      _headerC: '',
      _headerD: '',
      _headerE: '',
      _descA: '',
      _descB: '',
      _descC: '',
      _descD: '',
      _descE: '',
    }
  },
  directives: {
    textautosize,
  },
  computed: {
    userID () {
      return store.state.user.id
    },
    inComment () {
      return !(typeof this.commentID === 'undefined')
    },
    isOwner () {
      return this.owner === this.userID
    },
    isOwnerOrGroupAdmin () {
      return store.state.user.is_group_admin || this.isOwner
    },
    selectedA () {
      return this.valA === this.score
    },
    selectedB () {
      return this.valB === this.score
    },
    selectedC () {
      return this.valC === this.score
    },
    selectedD () {
      return this.valD === this.score
    },
    selectedE () {
      return this.valE === this.score
    },
  },
  props: {
    rubricID: {
      type: Number,
      required: true,
    },
    owner: {
      type: Number,
      required: true,
    },
    title: {
      required: true,
    },
    color: {
      type: String,
      required: true,
    },
    ascending: {
      type: Boolean,
      required: true,
    },
    descA: {
      type: String,
      required: false,
    },
    headerA: {
      type: String,
      required: false,
    },
    descB: {
      type: String,
      required: false,
    },
    headerB: {
      type: String,
      required: false,
    },
    descC: {
      type: String,
      required: false,
    },
    headerC: {
      type: String,
      required: false,
    },
    descD: {
      type: String,
      required: false,
    },
    headerD: {
      type: String,
      required: false,
    },
    descE: {
      type: String,
      required: false,
    },
    headerE: {
      type: String,
      required: false,
    },
    valA: {
      type: Number,
      required: false,
    },
    valB: {
      type: Number,
      required: false,
    },
    valC: {
      type: Number,
      required: false,
    },
    valD: {
      type: Number,
      required: false,
    },
    valE: {
      type: Number,
      required: false,
    },
    score: {
      type: Number,
      required: false,
    },
    scoreID: {
      type: Number,
      required: false,
    },
    tagID: {
      type: Number,
      required: true,
    },
    commentID: {
      required: false,
    },
    videoID: {
      required: false,
    },
  },
  methods: {
    close () {
      this.$emit('close')
    },
    async deleteTag (tagID) {
      await store.dispatch(deleteTag, tagID)
      this.showConfirm = false
    },
    async updateTagShare (event, tagID) {
      const groupTag = event.target.value
      await store.dispatch(updateTagShare, { tagID, groupTag })
    },
    async updateTagAndRubric () {
      const tagID = this.tagID
      const title = this._title
      const rubricID = this.rubricID
      const header1 = this._headerA
      const header2 = this._headerB
      const header3 = this._headerC
      const header4 = this._headerD
      const header5 = this._headerE
      const desc1 = this._descA
      const desc2 = this._descB
      const desc3 = this._descC
      const desc4 = this._descD
      const desc5 = this._descE
      const color = this.color
      await store.dispatch(updateTag, { tagID, title, color })
      await store.dispatch(updateRubricItem, { rubricID, header1, header2, header3, header4, header5, desc1, desc2, desc3, desc4, desc5 })
      this.editing = false
    },
    editTag () {
      this.editing = true
      this._title = this.title
      this._headerA = this.headerA
      this._headerB = this.headerB
      this._headerC = this.headerC
      this._headerD = this.headerD
      this._headerE = this.headerE
      this._descA = this.descA
      this._descB = this.descB
      this._descC = this.descC
      this._descD = this.descD
      this._descE = this.descE
    },
    async removeScore () {
      const { scoreID, videoID, commentID } = this
      await store.dispatch(removeScoreFromComment, { scoreID, videoID, commentID })
    },
    async scoreRubric (value) {
      const { videoID, commentID, tagID } = this
      await store.dispatch(addScoreToComment, { value, videoID, tagID, commentID })
    },
  },
}

</script>

<style lang="scss" scoped>
@import '../_variables.scss';

// override bulma to make modal wider
// this allows the descriptors to be wider
@media screen and (min-width: 769px), print {
  .modal-content, .modal-card {
    margin: 0 auto;
    max-height: calc(100vh - 40px) !important;
    width: 800px;
  }
}

.tag-title {
  max-width: 75%;
}

.modal-card-title {
  line-height: inherit;
  white-space: nowrap; 
  overflow-x: hidden;
  text-overflow: ellipsis;
  max-width: 90%;

  white-space: initial;
  flex-shrink: initial;
}

.fade-enter-active, .fade-leave-active {
  transition: all .1s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

// bulma override
.content p:not(:last-child) {
  margin-bottom: 0;
}

.rubric-option-container {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 10px;
  margin: 0;
}

// override bulma to make modal wider
// this allows the descriptors to be wider
@media screen and (min-width: 769px), print {
  .modal-content, .modal-card {
    margin: 0 auto;
    max-height: calc(100vh - 40px) !important;
    width: 800px;
  }
}

.rubric-option {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  flex-grow: 1;
  background-color: white;
  border-radius: 5px;
  box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
  padding: .75rem;
  white-space: initial;
  cursor: pointer;
  transform: translateY(0);
  transition: all 0.2s;
  // this will override the 'all' with only the properties we want to change
  transition-property: transform, box-shadow, background;
  will-change: transform, box-shadow, background;

  // don't change background on hover if disabled
  &:not(.disabled):hover {
    background-color: $cloud;
  }

  &:active {
    transform: translateY(2px);
  }

  &:last-child {
    margin-right: 0;
  }

  &.is-active {
    box-shadow: rgba(10, 10, 10, 0.1) 0px 9px 18px 0px, $teal 0px 0px 0px 4px;
    transform: translateY(-2px);
    background-color: gainsboro;
  }

}

.disabled.rubric-option {
  cursor: default;
  &:active:not(.is-active) {
    transform: none;
  }

  &:hover:not(.is-active) {
    background-color: inherit;
  }
}

.selected-container {
  display: none;
  justify-content: center;
  padding: 0.5rem;
}

</style>



// WEBPACK FOOTER //
// RubricItemModal.vue?1b318cb6